import { HighlightColor } from '@publizon/pubhub-reader';

export const getColorOptions = (theme, activeTheme) =>
  Object.entries(theme.reader[activeTheme].highlightColors).reduce(
    (acc, [name, value]) => ({ ...acc, [HighlightColor[name]]: value }),
    {},
  );
